import Vue from 'vue'
import * as Sentry from "@sentry/browser"
import { Vue as VueIntegration } from "@sentry/integrations"
import { Integrations } from "@sentry/tracing"

Sentry.init({
  dsn: "https://6a292b88673744fbbb0c632c06d72c18@o133629.ingest.sentry.io/5453570",
  integrations: [
    new Integrations.BrowserTracing(),
    new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
      tracing: true,
      tracingOptions: {
        trackComponents: true
      }
    })
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
})
